import { cleanFeatureCollection } from "./cleanFeatureCollection";

export const normalizeGisData = (gisData) => {
  if (!gisData) return;

  const normalizedGisData = gisData.map((dataset) => {
    if (!dataset) return {};
    return {
      baseUrl: dataset?.baseUrl || "",
      data: dataset?.data
        ? dataset?.data
        : dataset?.type === "FeatureCollection"
          ? cleanFeatureCollection(dataset)
          : null,
      icon: dataset?.icon || "",
      layerName: dataset?.layerName || "",
      layerTitle: dataset?.layerTitle || "Custom",
      layerType: dataset?.layerType || "",
      legendAttributes: dataset?.legendAttributes || [],
      selectedAttribute: dataset?.selectedAttribute || null,
      selectedTooltip: dataset?.selectedTooltip,
      title: dataset?.title || "Custom",
      type:
        dataset?.type === "FeatureCollection"
          ? "geojson"
          : dataset?.type
            ? dataset?.type
            : null,
      uid: dataset?.uid || "custom",
      withLegend: dataset?.withLegend || false,
      style: dataset?.style || "plain",
    };
  });

  const filteredNormalized = normalizedGisData?.filter(
    (data) => data?.style !== "hexabin" && data?.style !== "heatmap"
  );

  return filteredNormalized;
};
